import { useContext } from 'react';
import { ViewContext } from '../contexts/view-context';

export const useViews = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error('useViews must be used within a ViewContext Provider');
  }
  return context;
};
